import React from 'react';
import { Card, Row, Col, Statistic, Table, Tag, Button } from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();

  const { data: statsData, isLoading: statsLoading } = useQuery({
    queryKey: ['dashboardStats'],
    queryFn: async () => {
      const response = await api.get('/admin/stats');
      return response.data;
    }
  });

  const { data: requestsData, isLoading: requestsLoading } = useQuery({
    queryKey: ['recentRequests'],
    queryFn: async () => {
      const response = await api.get('/admin/service-requests?limit=5');
      return response.data;
    }
  });

  const statusColors: Record<string, string> = {
    pending: 'default',
    accepted: 'processing',
    delivered: 'success',
    completed: 'success',
    cancelled: 'error',
    expired: 'warning',
  };

  const columns = [
    {
      title: 'Samochód',
      dataIndex: ['car', 'licensePlate'],
      key: 'car',
      render: (_: any, record: any) => `${record.car?.brand} ${record.car?.model} (${record.car?.licensePlate})`,
    },
    {
      title: 'Klient',
      dataIndex: ['client', 'firstName'],
      key: 'client',
      render: (_: any, record: any) => `${record.client?.firstName} ${record.client?.lastName}`,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => <Tag color={statusColors[status]}>{status}</Tag>,
    },
    {
      title: 'Utworzono',
      dataIndex: 'requestedAt',
      key: 'requestedAt',
      render: (date: any) => {
        if (!date) return '-';
        const d = date instanceof Date ? date : new Date(date);
        return isNaN(d.getTime()) ? '-' : d.toLocaleString('pl-PL');
      },
    },
  ];

  return (
    <div>
      <h1>Dashboard</h1>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Aktywne żądania"
              value={statsData?.activeRequests || 0}
              prefix={<ClockCircleOutlined />}
              loading={statsLoading}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Ukończone dziś"
              value={statsData?.completedToday || 0}
              prefix={<CheckCircleOutlined />}
              loading={statsLoading}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Średni czas"
              value={statsData?.avgCompletionTime || 0}
              suffix="min"
              prefix={<ClockCircleOutlined />}
              loading={statsLoading}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Aktywni lokaje"
              value={statsData?.activeValets || 0}
              prefix={<UserOutlined />}
              loading={statsLoading}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card title="Ostatnie żądania">
            <Table
              dataSource={requestsData?.requests || []}
              columns={columns}
              rowKey="id"
              loading={requestsLoading}
              pagination={false}
              size="small"
            />
            <Button type="link" onClick={() => navigate('/requests')}>
              Zobacz wszystkie żądania
            </Button>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Żądania według statusu">
            <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <p>Wykres wkrótce...</p>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardPage;
